import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataBrokerResponse } from '../../models/data-broker/data-broker.interface';
import { AccessibilityPopUp } from '../../models/utils';
import { AppConfigService, CookieHelperService, handleError } from '../utils';
import { CommonServiceExtended } from './common-extended.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService extends CommonServiceExtended {
  lightFooter = false;
  axPopupContent: AccessibilityPopUp = {} as AccessibilityPopUp;
  config = inject(AppConfigService);
  cookieHelper = inject(CookieHelperService);
  http = inject(HttpClient);
  dataBroker$!: Observable<DataBrokerResponse>;
  _errorHandler = handleError.bind(this);

  checkLightHeaderFooter(): boolean {
    if (this.appConfig.get('APP_HEADERFOOTER_LIGHT_WEIGHT') === 'true') {
      this.lightFooter = true;
    } else {
      this.lightFooter = false;
    }
    return this.lightFooter;
  }

  hidingProfileSelector(): boolean {
    const hidingProfileSelectorURLs = this.appConfig
      .get('APP_RESTRICTED_PAGES_FOR_BUSINESS')
      .split(',');

    const url = window.location.pathname;
    const LOGIN_PICKER_IN_RESHOP_CONFIRMATION = [
      '/nextgencheckout/change-trip.html/confirmation',
      '/change-trip/confirmation'
    ];
    if (LOGIN_PICKER_IN_RESHOP_CONFIRMATION.includes(url)) {
      return false;
    }

    if (hidingProfileSelectorURLs.includes(url)) {
      return true;
    }

    return false;
  }

  getDeepLinkVendor(): string {
    if (this.appConfig.get('APP_DEEP_LINK_VENDOR')) {
      return this.appConfig.get('APP_DEEP_LINK_VENDOR');
    } else {
      return '';
    }
  }

  getDeepLinkVendorValue(cacheKeySuffix: string): string {
    const deepLinkSlimHeaderValue = this.cookieHelper.getCookieValue(
      'deepLinkVendor' + cacheKeySuffix
    );

    const cookieValue: string[] | null = this.checkValidDeepLinkCookie(
      deepLinkSlimHeaderValue
    );

    if (!cookieValue || !cookieValue[1]) {
      return '';
    } else {
      return cookieValue[1];
    }
  }

  setDeepLinkVendorCookie(vendorId: string, cacheKeySuffix: string): void {
    if (!vendorId) return;

    if (vendorId === this.getDeepLinkVendor()) {
      this.cookieHelper.setDeepLinkCookie(
        'deepLinkVendor' + cacheKeySuffix,
        vendorId
      );
      this.cookieHelper.setDeepLinkCookie('deepLinkCacheKey', cacheKeySuffix);
    } else {
      this.cookieHelper.deleteCookie('deepLinkVendor');
    }
  }

  checkValidDeepLinkCookie(
    deepLinkSlimHeaderValue: string | null
  ): string[] | null {
    return deepLinkSlimHeaderValue && deepLinkSlimHeaderValue.length > 0
      ? deepLinkSlimHeaderValue.split('=')
      : null;
  }

  setAxPopupContent(axPopupContent: AccessibilityPopUp): void {
    this.axPopupContent = axPopupContent;
  }
}
